import { getSectionHeadingPath } from '/src/utils/apiFunctions';
import httpClient from '/src/utils/httpClient';
import { pathTypes } from '/src/utils/sectionEnums';

export function updatePromoBarApiCall(options) {
  const {
    id,
    isPathDesign,
    message,
    color,
    textSize,
    isMasterPromobar,
    animation,
    opacity,

    CTAActionType,
    CTABackgroundColor,
    CTALinkId,
    CTABlockId,
    CTAOpacity,
    CTAUrl,
    CTAText,
    CTATextColor,
    CTABorder,
    CTABorderColor,
    CTAShadow,
    CTAShadowColor,
    CTAShape,
  } = options;

  return httpClient.put(getSectionHeadingPath(pathTypes.promobar, isPathDesign, id), {
    id,
    message,
    color,
    textSize,
    isMaster: isMasterPromobar,
    textAnimation: animation,
    opacity,

    ctaType: CTAActionType,
    ctaBackgroundColor: CTABackgroundColor,
    ctaItemId: CTALinkId,
    ctaBlockId: CTABlockId,
    ctaOpacity: CTAOpacity,
    ctaUrl: CTAUrl,
    ctaText: CTAText,
    ctaTextColor: CTATextColor,
    ctaBorder: CTABorder,
    ctaBorderColor: CTABorderColor,
    ctaShadow: CTAShadow,
    ctaShadowColor: CTAShadowColor,
    ctaShape: CTAShape,
  });
}
